import { Injectable } from '@angular/core';
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  // constructor(private mockAuthService: MockAuthService) {}

  // canActivate() {
  //   if (environment.mockAuthentication) {
  //     const authToken = this.mockAuthService.getToken();
  //     if (authToken) {
  //       return true
  //     }
  //   }
  //   return location.replace('auth/login');
  // }
  constructor(private router: Router, private userService: UserService) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const token = localStorage.getItem('token_key');
    if (token != null) {
      let roles;
      setTimeout(() => {
        roles = next.data['roles'] as Array<string>;
      }, 1);

      if (roles) {
        if (this.userService.roleMatch(roles)) {
          return true;
        } else {
          this.router.navigate(['/forbidden']);
          return false;
        }
      }
      return true;
    } else {
      this.router.navigate(['/auth/login']);
      return false;
    }
  }
}
